export default "https://cdn-static.gokick.com/assets/1c04a0e7cb9e690604c984af7e1d0f36647cf8e0/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";